var map = {
	"./f_lishizhang1.png": 6259,
	"./f_lishizhang2.png": 1768,
	"./hxj.png": 2808,
	"./lishi1.png": 3530,
	"./lishi2.png": 961,
	"./lishizhang1.png": 5900,
	"./lishizhang2.png": 4375,
	"./ljw.png": 7843,
	"./lzn.png": 7570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5722;